// extracted by mini-css-extract-plugin
export var active = "style-mod--active--0e976";
export var olavsPane = "style-mod--olavs-pane--27437";
export var olavsPaneButton = "style-mod--olavs-pane-button--a9104";
export var olavsPaneButtonHolder = "style-mod--olavs-pane-button-holder--74f75";
export var olavsPaneContent = "style-mod--olavs-pane-content--d2705";
export var olavsPaneDot = "style-mod--olavs-pane-dot--1e7c6";
export var olavsPaneFryingPan = "style-mod--olavs-pane-frying-pan--742e7";
export var olavsPaneGeneralFryingPan = "style-mod--olavs-pane-general-frying-pan--e701d";
export var olavsPaneImg = "style-mod--olavs-pane-img--06e83";
export var olavsPaneKnifeFryingPan = "style-mod--olavs-pane-knife-frying-pan--d5e1e";
export var olavsPanePanKnife = "style-mod--olavs-pane-pan-knife--ca4e3";
export var olavsPaneParagraph = "style-mod--olavs-pane-paragraph--3650c";
export var olavsPanePrice = "style-mod--olavs-pane-price--6cd68";
export var olavsPanePriceSale = "style-mod--olavs-pane-price-sale--2709c";
export var olavsPaneText = "style-mod--olavs-pane-text--acf92";
export var olavsPaneTextContent = "style-mod--olavs-pane-text-content--a4247";
export var olavsPaneTextImg = "style-mod--olavs-pane-text-img--e4a85";
export var olavsPaneTextImgContainer = "style-mod--olavs-pane-text-img-container--7e2bf";
export var olavsPaneTitle = "style-mod--olavs-pane-title--ae8a8";
export var olavsPaneWoodSpoon = "style-mod--olavs-pane-wood-spoon--507c8";
export var pulse = "style-mod--pulse--7846b";